<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex">
      <h4 class="page-title">
        <i class="fas fa-list-alt"></i>
        정책
      </h4>
      <ul class="breadcrumbs ml-auto">
        <li class="nav-home mr-1">
          <a href="#">
            <i class="fas fa-home text-muted"></i>
          </a>
        </li>
        <li class="nav-item">
          <a class="font_15" href="#">WMDS</a>
        </li>
        <li class="separator">
          <i class="flaticon-right-arrow"></i>
        </li>
        <li class="nav-item">
          <a class="font_15 font-weight-bold" href="#">정책</a>
        </li>
      </ul>
    </div>
    <b-row>
      <b-col lg="12" xl="12">
        <b-card>
          <div class="d-flex flex-wrap align-items-center">
            <div class="title mr-auto mb7">
              정책
              <br>
              <span class="font_12">확인 방법 설정</span>
            </div>
            <div class="mb7">
              <small class="float-right">{{model.created_at | datetime}}</small>
            </div>
          </div>
          <hr>
          <b-row class="mb-3" v-if="model && model.policy">
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="ph_policy" v-b-tooltip.hover>
                정책 설명
              </label>
            </b-col>
            <b-col class="col-xl-4 col-md-12  d-flex align-self-center">
              <b-form-input type="text" id="ph_descrip" v-model="model.description" :plaintext="lock"></b-form-input>
            </b-col>
          </b-row>
          <b-row class="mb-2">
            <b-col md="4">
              <b-form-group>
                <label for="ph_depth" style="border-bottom: 2px solid;" v-b-tooltip.hover title="첫 번째 페이지에서 다음 페이지로 링크를 이동(경로)하여 확인할지 여부를 입력합니다. 1-100 범위 내에서 지정할 수 있습니다.">최대 경로 깊이</label>
                <b-form-input type="number" id="ph_depth" :min="1" :max="100" v-model="model.policy.depth" :plaintext="lock"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group>
                <label for="ph_links" style="border-bottom: 2px solid;" v-b-tooltip.hover title="페이지 내에서 탐색할 최대 하위 링크를 입력합니다. 초과 링크를 무시하십시오. 일반적으로 한 페이지에 너무 많은 링크가 있으면 다른 페이지로 이동하기 전에 최대 탐색 페이지에 도달하게 됩니다. 정상적인 방식으로 확인되지 않도록 방지할 수 있습니다. 1~1,000 범위 내에서 지정할 수 있습니다.">하위 페이지 링크</label>
                <b-form-input type="number" id="ph_links" :min="1" :max="1000" v-model="model.policy.links" :plaintext="lock"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group>
                <label for="ph_limit" style="border-bottom: 2px solid;" v-b-tooltip.hover title="`검사하는 사이트에서 확인할 총 페이지 수입니다. 입력한 숫자에 도달하면 확인을 종료합니다. 1 ~ 라이선스 제한 범위 내에서 지정할 수 있습니다.`">최대 경로 페이지</label>
                <b-form-input type="number" id="ph_limit" :min="10" :max="limit" v-model="model.policy.limit" :plaintext="lock"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="mb-3">
            <b-col md="4">
              <b-form-group>
                <label for="ph_timeout" style="border-bottom: 2px solid;" v-b-tooltip.hover title="페이지 로드를 기다리는 시간입니다. 1-30 범위 내에서 지정할 수 있습니다.">시간 초과(초)</label>
                <b-form-input type="number" id="ph_timeout" :min="1" :max="30" v-model="model.policy.timeout" :plaintext="lock"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group>
                <label for="ph_delay" style="border-bottom: 2px solid;" v-b-tooltip.hover title="새 페이지로 이동하기 전에 기다려야 할 시간입니다. 1~10,000 범위 내에서 지정할 수 있습니다.">속도 확인(밀리초)</label>
                <b-form-input type="number" id="ph_delay" :min="0" :max="10000" v-model="model.policy.delay" :plaintext="lock"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <template v-if="lock">
            <template v-if="model.is_del">
              <!-- <b-button size="sm" variant="success" @click="revive"> 되살리기 </b-button> -->
              <span class="text-danger">삭제된 정책입니다.</span>
            </template>
            <template v-else>
              <b-button size="sm" variant="warning" @click="edit"> 편집 </b-button>
              <b-button size="sm" variant="danger" @click="remove"> 삭제 </b-button>
            </template>
          </template>
          <template v-else>
            <b-button size="sm" class="btn btn-add" @click="save"> 저장 </b-button>
            <b-button size="sm" variant="secondary" @click="cancel"> 취소 </b-button>
          </template>
          <b-button size="sm" class="float-right" variant="primary" @click="list"> 목록 </b-button>
        </b-card>
        <!-- <siteList v-if="model.id" :policy_id="model.id" :enable_new="false"></siteList> -->
      </b-col>
      <!-- <siteList class="col-md" v-if="model.id" :policy_id="model.id" :enable_new="false"></siteList> -->
    </b-row>
  </div>
</template>

<script>
  import App from './app.js'; export default Object.assign({}, App);
</script>